import { inject, Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Factory } from '../factory';
import {
  DEFAULT_TICKET_CATEGORIES,
  ETicketType,
  ITicketCategory,
  TicketCategoryId,
} from '@web/dtos';
import {
  ITicketCategoryForm,
  ITicketCategoryFormDataWrapper,
  ITicketCategoryFormWrapper,
} from '../../entities/ticket-category.entity';

@Injectable({
  providedIn: 'root',
})
export class TicketCategoryFormsFactoryService extends Factory<
  ITicketCategoryFormWrapper,
  ITicketCategory[]
> {
  private readonly formBuilder: FormBuilder = inject(FormBuilder);

  buildForm(
    entity: ITicketCategory[] = DEFAULT_TICKET_CATEGORIES
  ): FormGroup<ITicketCategoryFormWrapper> {
    return this.formBuilder.group<ITicketCategoryFormWrapper>({
      ticketCategories: this.formBuilder.array<FormGroup<ITicketCategoryForm>>(
        entity.map(
          (ticketCategory: ITicketCategory): FormGroup<ITicketCategoryForm> => {
            return this.buildTicketCategoryFormGroup(ticketCategory);
          }
        )
      ),
    });
  }

  buildTicketCategoryFormGroup(
    ticketCategory: ITicketCategory
  ): FormGroup<ITicketCategoryForm> {
    return this.formBuilder.group<ITicketCategoryForm>({
      id: this.formBuilder.control<TicketCategoryId | null>(
        ticketCategory?.id || null
      ),
      name: this.formBuilder.nonNullable.control<string>(ticketCategory?.name, [
        Validators.required,
      ]),
      position: this.formBuilder.nonNullable.control<number>(
        ticketCategory?.position,
        [Validators.required]
      ),
      ticketType: this.formBuilder.nonNullable.control<ETicketType>(
        ticketCategory?.ticketType,
        [Validators.required]
      ),
    });
  }

  buildEntity(forms: FormGroup<ITicketCategoryFormWrapper>): ITicketCategory[] {
    const wrapper = forms.getRawValue() as ITicketCategoryFormDataWrapper;

    const newTicketCategories: ITicketCategory[] = [];
    wrapper.ticketCategories.forEach(ticketCategory => {
      const newTicketCategory: any = {
        ...ticketCategory,
      };
      this.removeNullIds(newTicketCategory);
      newTicketCategories.push(newTicketCategory);
    });
    return newTicketCategories as ITicketCategory[];
  }
}
